import apiClient from './client';
import {TitleSuggestResponseMessage} from '@/types/TitleSuggestResponse';

/**
 * Fetches title suggestions matching the title query.
 * Chooses secure or public endpoint based on authentication state.
 * @param titleQuery Search text for title suggestions
 * @param secure Whether to use secure (/secure) or public (/public) endpoint
 */
export async function fetchTitleSuggest(
    titleQuery: string,
    secure: boolean = true
): Promise<TitleSuggestResponseMessage> {
  if (titleQuery.trim() === '') {
    return { videoMetadata: { videoMetadata: [] } };
  }
  const path = secure ? '/secure/title/suggest' : '/public/title/suggest';
  const response = await apiClient.get<TitleSuggestResponseMessage>(
    path,
    { params: { titleQuery } }
  );
  return response.data;
}
